import React, { useState } from 'react';
import styles from '../styles/components/SurveyComplete.module.css';
import { ActionButton } from '@ax2/common/components/ActionButton';
import PanelType, { getPanelTypeText } from '@ax2/common/model/PanelType';
import { setQuotas } from 'rest/makeSurveyClient';
import { useSurveyContext } from 'contexts/SurveyContext';
import { getQuotas, saveQuotas, saveQuotasStatus } from 'rest/shopClient';

export interface SurveyCompleteAction {
  title: string;
  onAction: () => void;
}

export interface SurveyQuotaAction {
  title: string;
  onCancelQuota: () => void;
  onSaveQuota: () => void;
  onShow: () => void;
  onHide: () => void;
}
export interface SurveyCompleteProps {
  QuotaStatus?: boolean;
  surveyName: string;
  panel: PanelType;
  back?: SurveyCompleteAction;
  complete: SurveyCompleteAction;
  loading?: boolean;
  setQuota?: SurveyQuotaAction;
}

const SurveyComplete: React.FC<SurveyCompleteProps> = ({
  QuotaStatus,
  surveyName,
  panel,
  back,
  complete,
  loading = false,
  setQuota,
}) => {
  const surveySchema = useSurveyContext();
  const getQuotaValue = (panel: string): number => {
    if (surveySchema) {
      return getQuotas(surveySchema.id, surveySchema.panel, panel);
    }
    return 0;
  };
  const [quotaValue1, setQuotaValue1] = useState(
    getQuotaValue(getPanelTypeText(panel).substring(0, 11))
  );
  const [quotaValue2, setQuotaValue2] = useState(
    getQuotaValue(
      getPanelTypeText(panel).substring(14, getPanelTypeText(panel).length)
    )
  );

  const handleSetQuota = () => {
    if (setQuota) {
      setQuota.onHide();
      setQuota.onSaveQuota();
    }

    if (surveySchema) {
      if (q == 'Health Plan & PBM')
        setQuotas(
          'HealthPlan',
          getQuotas(surveySchema.id, surveySchema.panel, 'Health Plan'),
          'PBM',
          getQuotas(surveySchema.id, surveySchema.panel, 'PBM'),
          surveySchema.id
        );
      else
        setQuotas(
          'HealthPlan',
          getQuotas(surveySchema.id, surveySchema.panel, 'Health Plan'),
          'HospitalNetwork',
          getQuotas(surveySchema.id, surveySchema.panel, 'Hospital System'),
          surveySchema.id
        );
      saveQuotasStatus(surveySchema.id, true);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = parseInt(e.target.value);

    if (inputValue > 20) {
      inputValue = 20;
    }
    setQuotaValue1(inputValue);
    setQuotaValue2(20 - inputValue);
    if (surveySchema) {
      if (q == 'Health Plan & PBM') {
        saveQuotas(surveySchema.id, 'Health Plan', inputValue);
        if (inputValue) saveQuotas(surveySchema.id, 'PBM', 20 - inputValue);
        else saveQuotas(surveySchema.id, 'PBM', 0);
      } else if (q == 'Health Plan & Hospital System') {
        saveQuotas(surveySchema.id, 'Health Plan', inputValue);
        saveQuotas(surveySchema.id, 'Hospital System', 20 - inputValue);
      }
    }
  };

  let q = getPanelTypeText(panel);
  const closeSetQuotaTab = () => {
    if (setQuota) {
      setQuota.onHide();
      setQuota.onCancelQuota();
    }
    if (surveySchema) saveQuotasStatus(surveySchema.id, false);
  };

  return (
    <div className={styles.container}>
      <p className={styles.description}>
        If you have already reviewed your full survey, you may now hit submit to
        send your survey to your selected Panel.
      </p>

      <table className={styles.groups}>
        <tbody>
          <tr>
            <td className={styles.groupTitle}>Survey Panel to be sent:</td>
            <td className={styles.groupText}>{surveyName}</td>
          </tr>
          <tr>
            <td className={styles.groupTitle}>Audience:</td>
            <td className={styles.groupText}>{`${getPanelTypeText(
              panel
            )} Panel`}</td>
          </tr>
        </tbody>
      </table>

      <div className={styles.buttons}>
        {back && (
          <div className={styles.button}>
            <ActionButton
              text={back.title}
              type="secondary"
              onClick={back.onAction}
            />
          </div>
        )}
        {setQuota &&
          (q === 'Health Plan & PBM' ||
            q === 'Health Plan & Hospital System') && (
            <>
              <div className={styles.button}>
                <ActionButton
                  text={setQuota.title}
                  type="primary"
                  onClick={() => setQuota.onShow()}
                />
              </div>
            </>
          )}
        <div className={styles.button}>
          <ActionButton
            text={complete.title}
            type="primaryAlt"
            onClick={() =>
              QuotaStatus == false && !loading && complete.onAction()
            }
            loading={loading}
          />
        </div>
      </div>
      <div className={styles.container}>
        {QuotaStatus && (
          <>
            <div className={styles.divcontainer}>
              <p className={styles.quotatext}>
                You can set your quota value in a range of 0 to 20.
              </p>
              <table className={styles.groups}>
                <tbody>
                  <tr>
                    <td className={styles.groupTitle}>
                      {' '}
                      {getPanelTypeText(panel).substring(0, 11)} :{' '}
                    </td>
                    <td className={styles.groupText}>
                      {' '}
                      <div className={styles.inputWrapper}>
                        <input
                          type="number"
                          value={quotaValue1}
                          onChange={handleInputChange}
                          className={styles.input}
                          min="0"
                          max="20"
                          required
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className={styles.groupTitle}>
                      {' '}
                      {getPanelTypeText(panel).substring(
                        13,
                        getPanelTypeText(panel).length
                      )}{' '}
                      :{' '}
                    </td>
                    <td className={styles.groupText}>
                      {' '}
                      <div className={styles.inputWrapper}>
                        <input
                          value={quotaValue2}
                          className={styles.input}
                          required
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className={styles.btns}>
                <div className={styles.btn}>
                  <ActionButton
                    text="Cancel"
                    type="secondary"
                    onClick={closeSetQuotaTab}
                  />
                </div>
                <div className={styles.btn}>
                  <ActionButton
                    text="Save"
                    type="primary"
                    onClick={handleSetQuota}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SurveyComplete;
